var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2102 16.6039C13.1605 17.2423 11.9279 17.61 10.6094 17.61C6.77671 17.61 3.66968 14.5029 3.66968 10.6702C3.66968 6.8375 6.77671 3.73047 10.6094 3.73047C14.4421 3.73047 17.5492 6.8375 17.5492 10.6702C17.5492 12.3958 16.9194 13.9743 15.8771 15.1883C15.8487 15.2214 15.82 15.2542 15.791 15.2867L16.1635 17.0229L14.2102 16.6039ZM17.6582 15.7251C18.6799 14.3021 19.2828 12.5551 19.2828 10.6702C19.2828 5.88003 15.3996 1.99683 10.6094 1.99683C5.81924 1.99683 1.93604 5.88003 1.93604 10.6702C1.93604 15.4604 5.81924 19.3436 10.6094 19.3436C11.9973 19.3436 13.3124 19.0164 14.4785 18.4345L18.4207 19.2801L17.6582 15.7251Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramComment);
export default __webpack_public_path__ + "static/media/instagramComment.4b518776.svg";
export { ForwardRef as ReactComponent };